<div class="page-view-tabs">
    <button class="btn scrollLeft" (click)="moveLeft()" *ngIf="!hideLeftBtn" [disabled]="disableLeftBtn"><i
            class="wms wms-chevron-left"></i></button>
    <ul class="nav nav-tabs scroll-container">
        <li>
            <a [ngClass]="{active: (selectedView.value ==  pageType)}"
                (click)="setPageType();onViewSelect.emit({selectedView:selectedView.value});">
                <span class="wm-text">{{pageInfo.isPartial ? locale.LABEL_PARTIAL : (isPrefabType ?
                    locale.LABEL_PREFAB : locale.LABEL_PAGE)}}</span>
            </a>
        </li>
        <li *ngFor="let view of views; let index = index">
            <a [ngClass]="{active:(selectedView.value === view)}" id="{{view.displayName}}"
                (click)="selectedView.value=view;onViewSelect.emit({selectedView:selectedView.value});">
                <i class="wm-icon view-list-icon wms wms-widget-{{view.iconClass}} pull-left" aria-hidden="true"></i>
                <span class="wm-text" title="{{view.displayName}}">{{view.displayName || view.name}}</span>
            </a>
        </li>
    </ul>
    <button class="btn scrollRight" (click)="moveRight()" *ngIf="!hideRightBtn" [disabled]="disableRightBtn"><i
            class="wms wms-chevron-right"></i></button>
</div>
